import Accordion from '../Page/Accordion';

export default Accordion;
